import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Typography } from "@material-tailwind/react";
import { NewspaperIcon } from "@heroicons/react/24/outline";
import RevistaSubscribeForm from "../components/RevistaSubscribeForm";
import { portalApi } from "../services/portalApi";

export default function PortalRevistas() {
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    portalApi
      .revistaCurrent()
      .then((r) => {
        if (!cancelled) setCurrent(r?.issue || null);
      })
      .catch(() => {
        if (!cancelled) setCurrent(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="max-w-xl mx-auto w-full min-w-0">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 text-brand-lavender mb-3">
          <NewspaperIcon className="h-6 w-6" aria-hidden />
          <span className="text-sm font-semibold tracking-wide uppercase">Conexión Siete</span>
        </div>
        <Typography
          variant="h1"
          className="font-sans text-brand-dark text-3xl font-semibold leading-tight"
        >
          Suscríbete a Conexión Siete
        </Typography>
        <p className="mt-3 text-brand-gray leading-relaxed">
          Recibe el ejemplar vigente por correo. Sin costo; puedes darte de baja cuando quieras.
        </p>
        {current?.title && (
          <p className="mt-3 text-sm text-brand-dark">
            Ejemplar actual: <strong>{current.title}</strong>
            {current.downloadUrl ? (
              <>
                {" "}
                ·{" "}
                <Link
                  to="/revistas/leer"
                  className="text-brand-lavender font-medium hover:underline"
                >
                  Leer ahora
                </Link>
              </>
            ) : null}
          </p>
        )}
      </div>

      <div className="rounded-2xl border border-brand-brown/15 bg-white/90 p-6 sm:p-8 shadow-sm">
        <RevistaSubscribeForm source="revistas" />
      </div>

      <p className="mt-6 text-sm text-brand-gray">
        <Link to="/" className="text-brand-lavender hover:underline">
          Volver al inicio
        </Link>
      </p>
    </div>
  );
}
